<template>
  <div class="footer fadeInUp animated">
    <div class="footer-list-bg">
      <div class="footer-list">
        <ul class="flex">
          <li>
            <h3>{{ $t("common.CompanyName") }}</h3>
            <h4>
              {{ $t("footer.Address") }}：{{ $t("common.CompanyAddress") }}
            </h4>
            <h4>{{ $t("footer.Phone") }}：15067699399 15857636096</h4>
            <h4>{{ $t("footer.EMail") }}：service@glangpump.com</h4>
            <h4>{{ $t("footer.Web") }}：www.glangtec.com</h4>
          </li>
          <li>
            <h2>{{ $t("top.About") }}</h2>

            <router-link to="/About?page=1">{{
              $t("top.Company_Profile")
            }}</router-link>

            <router-link to="/About?page=2">{{
              $t("top.Corporate_philosophy")
            }}</router-link>

            <router-link to="/About?page=3">{{
              $t("top.Corporate_Honors")
            }}</router-link>

            <router-link to="/About?page=4">{{
              $t("top.Company_Scenarios")
            }}</router-link>
          </li>
          <li>
            <h2>{{ $t("top.Products") }}</h2>
            <router-link
              :to="`/Products?id=${item.id}`"
              v-for="(item, index) in categoriesList"
              :key="'categoriesList' + index"
              >{{ item.title }}</router-link
            >
          </li>
          <li>
            <h2>{{ $t("top.News") }}</h2>

           <router-link to="/News">{{ $t("top.News") }}</router-link>
          </li>
          <li>
            <h2>{{ $t("top.Service") }}</h2>

            <router-link to="/Service">{{ $t("top.Service") }}</router-link>
          </li>
          <li>
            <h2>{{ $t("top.Contact") }}</h2>

             <router-link to="/Contact">{{ $t("top.Contact") }}</router-link>
          </li>
        </ul>
      </div>
      <div class="beian" v-if="beian_data">
       <p>{{beian_data.banquan.text}}</p>
       <p   v-for="(item, index) in beian_data.beian"
              :key="'beian' + index"><a :href="item.url">{{item.text}}</a></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  props: {},
  data () {
    return {
      img_head_url: '',
      categoriesList: [],
      lang: localStorage.lang || 'cn',
      beian_data: []
    }
  },
  created () {
    this.getCategoriesList()
    this.getBeiAn()
  },
  methods: {
    getBeiAn () {
      var that = this
      var json = {
        lang: that.lang
      }
      var url = '/api/get_beian'
      that.$lcommon.ajaxRequest('post', url, json, function (res) {
        console.log('get_beian')
        if (res.meta.status === 200) {
          that.beian_data = res.data
        }
      })
    },
    getCategoriesList () {
      var that = this
      var json = {
        lang: that.lang
      }
      var url = '/api/get_product_categories'
      that.$lcommon.ajaxRequest('post', url, json, function (res) {
        console.log('getCategoriesList')
        if (res.meta.status === 200) {
          that.categoriesList = res.data
        }
      })
    },
    // getFooterData () {
    //   var that = this
    //   var json = {
    //     lang: that.lang
    //   }
    //   var url = '/api/get_bottom_data'
    //   that.$lcommon.ajaxRequest('post', url, json, function (res) {
    //     console.log(res)
    //     if (res.meta.status === 200) {
    //       that.footerProductData = res.data.product.list
    //       that.footerNewsData = res.data.news_list
    //       that.img_head_url = res.img_head_url
    //     }
    //   })
    // },
    imgSrc (src) {
      var that = this
      return that.img_head_url + src
    },
    gotoProductDetail (id) {
      this.$router.push({ path: '/ProductDetail', query: { id: id } })
    },
    gotoNewDetail (id) {
      this.$router.push({ path: '/NewDetail', query: { id: id } })
    }
  }
}
</script>

<style scoped>
.footer {
  display: block;
  text-align: left;
  width: 100%;
  min-width: 1200px;
}

/*footer list*/
.footer-list-bg {
  background-color: #3f3f3f;
  position: relative;
  z-index: 5;
}

.footer-list {
  /* max-width: 1480px; */
  width: 80%;
  min-width: 1200px;
  margin: 0 auto;
  padding: 70px 0 30px;
  /*border-bottom: 1px solid #555;*/
}

.footer-list li h2 {
  font-size: 18px;
  color: #fff;
  margin-bottom: 20px;
  margin-top: 3px;
}

.footer-list li h2::after {
  display: block;
  content: "";
  margin-top: 15px;
  width: 30px;
  height: 5px;
  background-color: #478bb2;
}

.footer-list a,
.footer-list p {
  display: block;
  font-size: 16px;
  color: #ccc;
}

.footer-list a {
  text-decoration: none;
}

.footer-list a:hover {
  color: #fff;
  text-decoration: underline;
}

.footer-list a + a,
.footer-list p + p {
  margin-top: 20px;
}
.footer-list li:first-child {
  max-width: 40%;
  margin-right: 45px;
}

.footer-list li + li {
  padding-left: 2%;
  flex: 1;
}

.footer-list h3 {
  font-size: 30px;
  font-weight: bold;
  color: #fff;
  letter-spacing:3px;
  margin-bottom:20px;
  /* margin: 40px 0; */
}

.footer-list i {
  font-size: 30px;
  font-weight: normal;
  color: #fff;
}

.footer-list h4 {
  font-size: 16px;
  color: #ccc;
  margin-bottom: 20px;
  font-weight: normal;
}

.footer-list .qrbox {
  float: left;
  text-align: center;
  margin-right: 20px;
}

.footer-list .qrbox img {
  width: 97px;
  height: 97px;
  margin-bottom: 10px;
}
.footer .beian{
  text-align: center;
  color: #9D9D9D;
  padding: 0 0 10px 0;
  display: block;
  font-size: 12px;
  margin-top: 30px;
}
.footer .beian p{
  display: inline-block;
  margin-right: 14px;
  font-size: 12px;
}
.footer .beian p a{
  color: #9D9D9D;
  font-size: 12px;
}
</style>
